module.exports = {"defaultVersion":"小辰哥的Java v2.0","isEnableDeployUrl":false,"deployUrl":"http://edu.qiudb.top","developmentUrl":"http://49.234.26.179:8000"}


//////////////////
// WEBPACK FOOTER
// ./static/config.json
// module id = IuJc
// module chunks = 35